// @flow
import React from 'react';
import CardCarousel from '@homeaway/react-card-carousel';
import PropertyCard from './PropertyCard/PropertyCard';
import type {PropertyCardListingShape} from './PropertyCard/PropertyCard';

type Props = {
    isMobile: boolean,
    title: string,
    breakpoints: Object,
    listings: PropertyCardListingShape[]
};

const renderCards = (listings, isMobile) => {
    return listings.map((listing) => (
        <PropertyCard
            listing={listing}
            isMobile={isMobile}
            key={listing.listingId}
        />
    ));
};

export const PropertyCarousel = (props: Props) => {
    const {isMobile, title, breakpoints, listings} = props;

    return (
        <CardCarousel
            breakpoints={breakpoints}
            scrolling={isMobile}
            title={title}
        >
            {renderCards(listings, isMobile)}
        </CardCarousel>
    );
};

export default PropertyCarousel;
